<template>
  <div class="app-container">
    <div class="filter-container" style="width: 100%;display: flex;flex-wrap: wrap;">
      <el-select filterable v-model="listQuery.shop_id" placeholder="请选择店铺" class="filter-item" style="width: 220px" clearable>
        <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id"></el-option>
      </el-select>

      <el-select class="filter-item" v-model="listQuery.type" placeholder="类型" style="width: 140px" clearable>
        <el-option label="赔付" :value="1"></el-option>
        <el-option label="提现申请" :value="2"></el-option>
        <el-option label="提现回退" :value="3"></el-option>
        <el-option label="系统充值" :value="4"></el-option>
        <el-option label="系统回收" :value="5"></el-option>
        <el-option label="现场收款" :value="6"></el-option>
        <el-option label="渠道分佣" :value="7"></el-option>
        <el-option label="系统分账" :value="8"></el-option>
        <el-option label="店铺充值" :value="9"></el-option>
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>

      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="店铺钱包明细.xls" worksheet="店铺钱包明细">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="店铺id" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop_id }}
        </template>
      </el-table-column>

      <el-table-column label="店铺名称" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop.shop_name }}
        </template>
      </el-table-column>

      <el-table-column label="类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type === 1">赔付</el-tag>
          <el-tag type="danger" v-else-if="scope.row.type === 2">提现申请</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 3">提现回退</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 4">系统充值</el-tag>
          <el-tag type="danger" v-else-if="scope.row.type === 5">系统回收</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 6">现场收款</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 7">渠道分佣</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 8">系统分账</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === 9">店铺充值</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="改变前" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.before }}
        </template>
      </el-table-column>

      <el-table-column label="改变值" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.change }}
        </template>
      </el-table-column>

      <el-table-column label="改变后" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.after }}
        </template>
      </el-table-column>

      <el-table-column label="备注" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark }}
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import downloadExcel from "vue-json-excel";
  import moment from "moment";

  export default {
    components: {
      downloadExcel
    },
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          shop_id: "",
          type: "",
          start_date: "",
          end_date: "",
        },
        shops: [],
        dateArr: null,
        json_fields: {
          店铺ID: "shop_id",
          店铺名称: "shop.shop_name",
          类型: {
            field: "type",
            callback: (value) => {
              if (value === 1) return "赔付";
              else if (value === 2) return "提现申请";
              else if (value === 3) return "提现回退";
              else if (value === 4) return "系统充值";
              else if (value === 5) return "系统回收";
              else if (value === 6) return "现场收款";
              else if (value === 7) return "渠道分佣";
              else if (value === 8) return "系统分账";
              else if (value === 9) return "店铺充值";
              else return "";
            }
          },
          改变前: "before",
          改变值: "change",
          改变后: "after",
          备注: {
            field: "remark",
            //自定义回调函数
            callback: (value) => {
              return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
            },
          },
          创建时间: {
            field: "created_at",
            //自定义回调函数
            callback: (value) => {
              return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
            },
          },
        },
        exportLoading: false,
      };
    },
    created() {
      if (this.$route.query.shop_id) {
        this.listQuery.shop_id = this.$route.query.shop_id-0
      }
      this.listQuery.start_date = moment().format("YYYY-MM-DD");
      this.listQuery.end_date = moment().format("YYYY-MM-DD");
      this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
      this.getList();
      this.getShopList();
    },
    computed: {
      ...mapGetters(["schools", "school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.getShopList();
      },
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_date = newVal[0];
          this.listQuery.end_date = newVal[1];
        } else {
          this.listQuery.start_date = "";
          this.listQuery.end_date = "";
        }
      }
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/wallet/shopWalletLog",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getShopList() {
        request({
          url: "/api/backend/shop/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id,
          }
        }).then(response => {
          this.shops = response.data.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      handleExport() {
        if (!this.listQuery.start_date || !this.listQuery.end_date) {
          this.$message({
            type: "warning",
            message: "请选择时间段"
          });
          return;
        }

        let listQuery = JSON.parse(JSON.stringify(this.listQuery));
        listQuery.page = 1;
        listQuery.limit = this.total;
        this.exportLoading = true;
        return request({
          url: "/api/backend/wallet/shopWalletLog",
          method: "get",
          params: listQuery,
          timeout: 6000000,
        }).then(response => {
          if (response.data.data.length <= 0) {
            this.$message({
              type: "warning",
              message: "暂无记录"
            });
            return;
          }
          return response.data.data;
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.exportLoading = false;
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
